export interface NftLookupProps {
  tokenId: string;
  onChange(tokenId: string): void;
  onSubmit(): void;
}

export function NftLookup({ tokenId, onChange, onSubmit }: NftLookupProps) {
  return <form className="nft-lookup" onSubmit={(event) => {
    event.preventDefault();
    onSubmit();
  }}>
    <label htmlFor="nft-token-id">Find an NFT in this collection</label>
    <div><input id="nft-token-id" inputMode="numeric" value={tokenId} onChange={(event) => onChange(event.target.value)} placeholder="Token ID" />
      <button className="secondary-action" type="submit" disabled={!tokenId.trim()}>View NFT</button></div>
    <p>You can finalize a ready NFT without owning it. Select its source token first.</p>
  </form>;
}
